import React from 'react';

export default function PriceBreakdown({ form, booths, dbAddons = [], total }) {
  const booth = booths?.find(b => b.title === form.booth_type);
  const boothPrice = booth ? parseFloat(booth.base_price) || 0 : 0;

  // Add-ons (dynamic database-driven)
  const addons = [];
  if (form.selected_addons && Array.isArray(form.selected_addons)) {
    form.selected_addons.forEach(item => {
      const addon = dbAddons.find(a => a.id === item.id);
      if (addon) {
        const qty = parseInt(item.quantity) || 1;
        const price = parseFloat(addon.price) || 0;
        if (addon.type === 'boolean') {
          addons.push({
            label: addon.name,
            price: price,
            note: price === 0 ? 'Included' : ''
          });
        } else {
          addons.push({
            label: `${addon.name} (x${qty})`,
            price: price * qty,
            note: price === 0 ? 'Included' : ''
          });
        }
      }
    });
  }

  // Selected Backdrop as a distinct addon line item
  if (form.backdrop_id && form.backdrop_name) {
    const backdropPrice = parseFloat(form.backdrop_price) || 0;
    addons.push({
      label: `Backdrop: ${form.backdrop_name}`,
      price: backdropPrice,
      note: backdropPrice === 0 ? 'Included' : ''
    });
  }

  const lineItem = (label, price, note = '') => (
    <div key={label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
      <div>
        <span style={{ fontSize: 13, color: '#e0e0e0' }}>{label}</span>
        {note && <span style={{ fontSize: 11, color: '#a0a0b8', marginLeft: 8 }}>({note})</span>}
      </div>
      <span style={{ fontSize: 13, color: '#27C85A', fontWeight: 600 }}>
        {note === 'Included' ? 'Included' : `+$${price.toFixed(2)}`}
      </span>
    </div>
  );

  return (
    <div style={{ background: 'rgba(255,255,255,0.03)', borderRadius: 12, padding: '4px 16px', border: '1px solid rgba(255,255,255,0.06)', marginBottom: 24 }}>
      <div style={{ padding: '10px 0', borderBottom: '1px solid rgba(227,67,100,0.2)' }}>
        <span style={{ fontSize: 13, color: '#E34364', fontWeight: 700 }}>💰 Price Breakdown</span>
      </div>

      {form.booth_type
        ? <>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
              <span style={{ fontSize: 13, color: '#e0e0e0' }}>{form.booth_type} — Base Rate (2 hours)</span>
              <span style={{ fontSize: 13, color: '#27C85A', fontWeight: 600 }}>+${boothPrice.toFixed(2)}</span>
            </div>
            {(() => {
              const duration = parseInt(form.duration_hours) || 2;
              if (duration > 2) {
                const extraHours = duration - 2;
                const hourlyAddon = dbAddons?.find(a => a.type === 'hourly');
                const extraRate = hourlyAddon ? parseFloat(hourlyAddon.price) : 75.00;
                const extraCost = extraHours * extraRate;
                return (
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
                    <span style={{ fontSize: 13, color: '#e0e0e0' }}>Extra Duration Coverage ({extraHours}h @ ${extraRate.toFixed(2)}/hr)</span>
                    <span style={{ fontSize: 13, color: '#27C85A', fontWeight: 600 }}>+${extraCost.toFixed(2)}</span>
                  </div>
                );
              }
              return null;
            })()}
          </>
        : <div style={{ padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.04)', color: '#555', fontSize: 13 }}>
            Select a booth type to see pricing
          </div>
      }

      {addons.length > 0 && addons.map(a => lineItem(a.label, a.price, a.note))}

      {addons.length === 0 && form.booth_type && (
        <div style={{ padding: '8px 0', color: '#555', fontSize: 12 }}>No add-ons selected</div>
      )}

      {/* Total */}
      {(() => {
        const subtotal = parseFloat((total / 1.0825).toFixed(2));
        const tax = parseFloat((total - subtotal).toFixed(2));
        return (
          <div style={{ padding: '14px 0 8px', borderTop: '1px solid rgba(255,255,255,0.06)', marginTop: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
              <span style={{ fontSize: 13, color: '#a0a0b8' }}>Subtotal</span>
              <span style={{ fontSize: 14, color: '#fff', fontWeight: 600 }}>${subtotal.toFixed(2)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
              <span style={{ fontSize: 13, color: '#a0a0b8' }}>Sales Tax (8.25%)</span>
              <span style={{ fontSize: 14, color: '#fff', fontWeight: 600 }}>${tax.toFixed(2)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: 15, color: '#fff', fontWeight: 700 }}>Total Quote</span>
              <span style={{ fontSize: 22, color: '#E34364', fontWeight: 700 }}>${total.toFixed(2)}</span>
            </div>
          </div>
        );
      })()}
    </div>
  );
}
